// @flow

import React from 'react';
import { Card, Text } from '../';

type Props = {
  bgColor: String,
  color: String,
  text: String,
  textSize?: String,
  textClassName?: String,
  className?: String,
};

export default function Badge(props: Props) {
  const {
    bgColor,
    color,
    text,
    textSize,
    className,
    textClassName,
    ...rest
  } = props;

  return (
    <Card
      type={bgColor}
      className={`w-max px-1 ${className}`}
      hasShadow={false}
      {...rest}
    >
      <Text color={color} size={textSize} className={`px-1 ${textClassName}`}>
        {text}
      </Text>
    </Card>
  );
}
